import { FormEvent, forwardRef, useEffect } from "react";
import { BonusDto } from "../Deposit";
import { ButtonVariable, useAppSelector } from "@hypexone/uicore";
import SelectTemplate from "../common/SelectTemplate";
import Button from "../../../components/shared/Button/Button";

interface PaytringTabPanelProps {
  index: number;
  tabValue: number;
  submitPaytring: (e: FormEvent, selectedPaymentGateway?: string) => void;
  depositAmount: string;
  setDepositAmount: (amount: string) => void;
  loading: boolean;
  providersList: any;
  buttonVariables: ButtonVariable[];
  bonusTypes: BonusDto[];
  setBonusTypes: Function;
  selectedBonus: string;
  setSelectedBonus: (selectedBonus: string) => void;
  getBonusTypes: (amount: number) => Promise<BonusDto[]>;
}

const Paytring = forwardRef<HTMLInputElement, PaytringTabPanelProps>(
  ({
    index,
    providersList,
    tabValue,
    submitPaytring,
    depositAmount,
    setDepositAmount,
    loading,
    buttonVariables,
    bonusTypes,
    setBonusTypes,
    selectedBonus,
    setSelectedBonus,
    getBonusTypes,
  }) => {
    const {langData} = useAppSelector((state) => state.cms);
    const setBetAmount = (amount: string, type: string) => {
      if (type === "ADD" && !(bonusTypes.length > 1)) {
        setDepositAmount(String(+depositAmount + +amount));
      }
    };

    const getBonuses = async (e: any) => {
      e.preventDefault();
      const bonuses: BonusDto[] = await getBonusTypes(+depositAmount);
      if (bonuses.length === 0) {
        submitPaytring(e, "paytring");
      }
    };

    useEffect(() => {
      setBonusTypes([]);
      setSelectedBonus(null);
    }, []);

    return (
      <div className={`w-full ${tabValue !== index ? "hidden" : ""}`}>
        {providersList?.length > 0 ? (
          <form onSubmit={(e) => getBonuses(e)} className="space-y-6 py-3">
            <div className="grid grid-cols-3 gap-1">
              {buttonVariables.map((bV, idx) => (
                < Button
                  key={"qb-btn" + idx}
                  type="button"
                  className="py-2 px-4 bg-blue-700 text-white rounded hover:bg-blue-600"
                  onClick={() => setBetAmount(bV.stake.toString(), "ADD")}
                >
                  +{bV.label}
                </ Button>
              ))}
            </div>

            <div>
              <label
                htmlFor="depositAmount"
                className="block text-gray-600 mb-1"
              >
                {langData?.['enter_amount_inr']}
              </label>
              <input
                type="number"
                id="depositAmount"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={depositAmount}
                onChange={(e) => setDepositAmount(e.target.value)}
                placeholder={langData?.['enter_deposit_amount_txt']}
                disabled={bonusTypes && bonusTypes.length > 1}
              />
              <div className="mt-2">
                < Button
                  type="button"
                  className="text-blue-600 underline hover:text-black"
                  onClick={() => {
                    if (!(bonusTypes && bonusTypes.length > 1)) {
                      setDepositAmount("0");
                    }
                  }}
                >
                  {langData?.['clear']}
                </ Button>
              </div>
            </div>

            {!bonusTypes || bonusTypes.length <= 1 ? (
              < Button
                type="submit"
                disabled={loading || !depositAmount}
                className={`w-full py-3 rounded text-white ${
                  loading || !depositAmount
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {loading ? langData?.['loading'] + "..." : langData?.['next']}
              </ Button>
            ) : (
              <>
                <div className="mt-4">
                  <label
                    htmlFor="bonusType"
                    className="block text-gray-600 mb-1"
                  >
                    {langData?.['select_bonus_type']}
                  </label>
                  <SelectTemplate
                    label={langData?.['select_bonus_type']}
                    value={selectedBonus}
                    list={bonusTypes.map((bt) => ({
                      value: bt.id,
                      name: bt.name,
                    }))}
                    onChange={(e: any) => setSelectedBonus(e.target.value)}
                    placeholder={langData?.['bonus_type']}
                  />
                </div>

                < Button
                  type="submit"
                  className={`w-full py-3 rounded text-white ${
                    loading || !depositAmount
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-blue-600 hover:bg-blue-700"
                  }`}
                  onClick={(e) => submitPaytring(e, "paytring")}
                  disabled={loading}
                >
                  {loading ? langData?.['loading'] + "..." : langData?.['next']}
                </ Button>
              </>
            )}
          </form>
        ) : (
          <div className="text-center text-gray-500 mt-8">
            {langData?.['providers_not_found_txt']}
          </div>
        )}
      </div>
    );
  }
);

export default Paytring;
